import { createSelector } from 'reselect';
import { Global } from '../state/Global';

const userProfileState = (state: Global) => state.app.get('userProfile', null);

const selectUserProfile = createSelector(
  userProfileState,
  (state) => {
    return state ? state.user : null;
  }
);

export {
  selectUserProfile
};
